import request from '../tools/request'

export function login (body) {
  return request({
    url: '/api/login',
    method: 'post',
    params: body
  })
}
// export function logintest (body) {
//   return request({
//     url: '/user/login',
//     method: 'get',
//     params: body
//   })
// }
export function logOut () {
  return request({
    url: '/api/logout',
    method: 'get'
  })
}

export function test (body) {
  return request({
    url: '/api/test',
    method: 'get',
    params: body
  })
}

export function updateUserPassword (body) {
  return request({
    url: 'api/system/user/updateUserPassword',
    method: 'post',
    params: body
  })
}

// export function secondaryLogin (body) {
//   return request({
//     url: '/api/secondaryLogin',
//     method: 'post',
//     params: body
//   })
// }

// 查询预警和任务未处理接口
export function searchWarningAndTaskIsDeal (body) {
  return request({
    url: '/api/SearchWarningAndTaskIsDeal',
    method: 'get',
    params: body
  })
}

// 单点登录
export function loginUid (body) {
  return request({
    url: '/apis/login',
    method: 'post',
    params: body
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js